// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3aRZm","row":"Node_row__2VjqJ","label":"Node_label__2PDUm","footer":"Node_footer__3Ye7X"};